"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.numberCleaner = void 0;
const numberCleaner = (value, decimalPlaces = 2) => {
    const roundedThreshold = Math.pow(10, decimalPlaces);
    return Math.round(value * roundedThreshold) / roundedThreshold;
};
exports.numberCleaner = numberCleaner;
//# sourceMappingURL=numberCleaner.js.map